import { useQuery } from '@tanstack/react-query';
import plannedTransactionsApi from '@/features/dashboard/plannedTransactions/api/plannedTransactionsApi.ts';
import { plannedTransactionsApiQueryKeys } from '@/features/dashboard/plannedTransactions/api/plannedTransactionsApi.queryKeys.ts';

const useGetPlannedTransaction = (transactionId: string) => {
  return useQuery({
    queryKey: plannedTransactionsApiQueryKeys.byId(transactionId),
    queryFn: () => plannedTransactionsApi.getById(transactionId),
    enabled: !!transactionId,
  });
};

export default useGetPlannedTransaction;
